module.exports = __webpack_public_path__ + "img/icon6.dac99109.png";